<div class="cart-item" *ngIf="!!product && !!price">
  <div class="row pb-2 pt-2 align-items-center">
    <button class="btn btn-light checkout-cart-step-delete-button" (click)="removeRow(data)">
      <i class="fas fa-times"></i>
    </button>
    <div class="col-2 col-md-2 d-flex align-items-center pb-1">
      <img
        class="img-fluid"
        src="https://cdn1.gung.io/fit-in/150x150/filters:fill(white):background_color(white):format(jpeg)/{{
          product.extra.images[0].s3Uri
        }}"
        alt=""
      />
    </div>

    <div class="col-10 col-md-3 order-md-1 text-truncate">
      <div class="product-name">
        <b>{{ product.id }}</b> - {{ product.name }}
      </div>
      <div *ngIf="productAddons">
        <div class="pb-1 text-truncate small" *ngFor="let addon of productAddons.addons; trackBy: trackByAddon">
          <i class="fas fa-plus checkout-addon-icon"></i>&nbsp;{{ addon.product.id }} - {{ addon.product.name }}
        </div>
      </div>
    </div>

    <div class="col-6 col-md-2 order-md-2">
      <div class="row pt-1 pl-2">
        <div class="col-4 d-flex d-md-none small-title">
          <b translate>QUANTITY</b>
        </div>
        <!--
        <div class="col-8 d-flex col-md-12">
          <lib-buy-btn class="colmec-user-buy-button" [id]="data.productId"></lib-buy-btn>
        </div>
        -->
        <div class="col-8 d-flex col-md-12">
          <colmec-buy-btn
            class="colmec-user-buy-button"
            [id]="data.productId"
            [product]="product"
            [id]="product?.id"
            [minimumOrderQuantity]="product?.extra.ar.artfsgforp"
            [stepAmount]="product?.extra.ar.artfsgforp"
          >
          </colmec-buy-btn>
        </div>
      </div>
    </div>

    <div class="col-6 col-md-3 order-md-3">
      <div class="row pt-1 pl-2">
        <div class="col-4 d-flex d-md-none small-title">
          <b translate>PRICE</b>
        </div>
        <div class="col-8 col-md-12 text-md-center">
          <lib-price
            [price]="price.cartRowUnitPriceInclRowDiscount.value"
            [currency]="price.cartRowUnitPriceInclRowDiscount.currencyCode"
          ></lib-price>
        </div>
      </div>
    </div>

    <div class="col-6 col-md-2 order-md-4">
      <div class="row pt-1 pl-2">
        <div class="col-4 d-flex d-md-none small-title">
          <b translate>TOTAL</b>
        </div>
        <div class="col-8 col-md-12 text-md-center price-cart-checkout">
          <lib-price
            [price]="price.cartRowTotalPriceInclRowDiscount.value"
            [currency]="price.cartRowTotalPriceInclRowDiscount.currencyCode"
          ></lib-price>
        </div>
      </div>
    </div>

    <div
      class="vhr col-12 col-md-3 order-md-6 pt-2"
      *ngIf="availability && availability.currentAvailability < data.qty"
    >
      <div class="row d-flex pt-1">
        <div class="col">
          <colmec-availability-warning> </colmec-availability-warning>
        </div>
      </div>
    </div>
  </div>
</div>
